<template>
  <div class="min-h-screen bg-white flex flex-col">
    <TrustBar />
    <main class="flex-1 pt-[120px] pb-12">
      <div class="max-w-4xl mx-auto px-4">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Comment ça marche ?</h1>

        <div class="prose prose-gray max-w-none">
          <section class="mb-12">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Nos produits</h2>
            <p class="text-gray-600 mb-6">
              Fluxreload vous permet d'acheter instantanément des produits numériques pour vos besoins quotidiens :
            </p>
            <div class="grid md:grid-cols-2 gap-6">
              <div class="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6">
                <h3 class="text-lg font-semibold text-purple-900 mb-2">🎁 Cartes cadeaux</h3>
                <p class="text-gray-700 text-sm">Amazon, Netflix, iTunes, Google Play, PlayStation, Xbox, Steam... pour vos achats en ligne</p>
              </div>
              <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6">
                <h3 class="text-lg font-semibold text-blue-900 mb-2">💳 Cartes de paiement</h3>
                <p class="text-gray-700 text-sm">Cartes PCS virtuelles pour vos paiements sécurisés sur les sites internationaux</p>
              </div>
              <div class="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6">
                <h3 class="text-lg font-semibold text-green-900 mb-2">📱 Recharges mobiles</h3>
                <p class="text-gray-700 text-sm">Crédit téléphonique, forfaits internet pour MTN, Orange, Moov, et plus encore</p>
              </div>
              <div class="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6">
                <h3 class="text-lg font-semibold text-orange-900 mb-2">🌍 eSIM voyages</h3>
                <p class="text-gray-700 text-sm">Connexion internet dans plus de 100 pays pour rester connecté lors de vos déplacements</p>
              </div>
            </div>
          </section>

          <section class="mb-12">
            <h2 class="text-2xl font-semibold text-gray-900 mb-6">Comment commander ?</h2>

            <div class="space-y-6">
              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">1</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Sélectionnez votre produit</h3>
                  <p class="text-gray-600">Choisissez parmi nos cartes cadeaux, cartes PCS, recharges ou eSIM. Sélectionnez le montant souhaité et votre pays.</p>
                </div>
              </div>

              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">2</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Entrez votre email</h3>
                  <p class="text-gray-600">Renseignez votre adresse email. C'est ici que vous recevrez votre code après le paiement, donc assurez-vous qu'elle est correcte.</p>
                </div>
              </div>

              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">3</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Choisissez votre moyen de paiement</h3>
                  <p class="text-gray-600 mb-2">Nous proposons deux options de paiement sécurisé :</p>
                  <ul class="list-disc list-inside text-gray-600 space-y-1 mt-2">
                    <li><strong>Stripe</strong> : paiement par carte bancaire (Visa, Mastercard...)</li>
                    <li><strong>PayPal</strong> : paiement via votre compte PayPal</li>
                  </ul>
                  <p class="text-gray-600 text-sm mt-3">🔒 Tous les paiements sont sécurisés et conformes aux normes PCI-DSS. Vos coordonnées bancaires ne sont jamais stockées sur nos serveurs.</p>
                </div>
              </div>

              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">4</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Validez et payez</h3>
                  <p class="text-gray-600">Vérifiez le montant total (produit + frais de service de 2%) dans le résumé de commande, puis validez votre paiement. Le traitement est instantané.</p>
                </div>
              </div>

              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">5</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Recevez votre code instantanément</h3>
                  <p class="text-gray-600">Une seconde après votre paiement, vous recevez votre code par email. Pas d'attente, instantané !</p>
                </div>
              </div>

              <div class="flex gap-6 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 text-white rounded-2xl flex items-center justify-center font-bold text-2xl shadow-lg">6</div>
                <div class="flex-1">
                  <h3 class="text-xl font-semibold text-gray-900 mb-2">Utilisez votre code</h3>
                  <p class="text-gray-600">Pour les cartes cadeaux : entrez le code sur le site ou l'application du marchand concerné. Pour les cartes PCS : utilisez vos coordonnées pour vos achats en ligne. Pour les recharges : le crédit est crédité automatiquement sur votre mobile.</p>
                </div>
              </div>
            </div>
          </section>

          <section class="mb-12">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Pourquoi choisir Fluxreload ?</h2>
            <div class="grid md:grid-cols-3 gap-6">
              <div class="text-center p-6">
                <div class="text-5xl mb-4">⚡</div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Livraison instantanée</h3>
                <p class="text-gray-600 text-sm">Vos codes sont envoyés par email moins d'une minute après votre paiement</p>
              </div>
              <div class="text-center p-6">
                <div class="text-5xl mb-4">🔒</div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Paiement sécurisé</h3>
                <p class="text-gray-600 text-sm">Stripe et PayPal pour des transactions 100% sécurisées</p>
              </div>
              <div class="text-center p-6">
                <div class="text-5xl mb-4">🌍</div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Multi-devises</h3>
                <p class="text-gray-600 text-sm">Payez en FCFA, USD, EUR et autres devises avec conversion automatique</p>
              </div>
            </div>
          </section>

          <section class="mb-12">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Questions fréquentes</h2>
            <div class="space-y-6">
              <div class="border-b pb-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Quels moyens de paiement acceptez-vous ?</h3>
                <p class="text-gray-600">Nous acceptons les cartes bancaires (via Stripe) et les paiements PayPal. Tous les paiements sont sécurisés selon les normes les plus strictes.</p>
              </div>
              <div class="border-b pb-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Comment fonctionne la livraison ?</h3>
                <p class="text-gray-600">La livraison est 100% numérique par email. Vous recevez votre code de recharge, PIN ou identifiants de carte directement dans votre boîte mail.</p>
              </div>
              <div class="border-b pb-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Quels sont les frais de service ?</h3>
                <p class="text-gray-600">Un frais de service de 2% s'ajoute au prix du produit. Ce frais est clairement affiché dans le résumé de commande avant paiement, donc aucun surprise !</p>
              </div>
              <div class="border-b pb-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Puis-je obtenir un remboursement ?</h3>
                <p class="text-gray-600">En raison de la nature numérique de nos produits, les ventes sont définitives une fois le code envoyé. Cependant, si un code est défectueux, nous le remplaçons sous 48h.</p>
              </div>
              <div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">Le site est-il disponible 24h/24 ?</h3>
                <p class="text-gray-600">Oui, notre service est accessible 24 heures sur 24, 7 jours sur 7. Vous pouvez commander à tout moment, de n'importe où dans le monde.</p>
              </div>
            </div>
          </section>

          <section class="bg-gradient-to-r from-purple-50 to-blue-50 rounded-2xl p-8 text-center">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Besoin d'aide ?</h2>
            <p class="text-gray-600 mb-6">
              Notre équipe est disponible pour répondre à toutes vos questions. N'hésitez pas à nous contacter via notre page de contact.
            </p>
            <router-link to="/help" class="inline-block bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:from-purple-700 hover:to-blue-700 transition-all">
              Visiter le centre d'aide
            </router-link>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue';
</script>

<style scoped>
.prose {
  color: #374151;
  line-height: 1.75;
}

.prose h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.25;
}

.prose p {
  margin-bottom: 1.25em;
}

.prose h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.25;
}
</style>
